// IndexCore Mock Data

export const navigation = [
  { name: 'Qui sommes-nous ?', href: '/about' },
  { name: 'Notre histoire', href: '/histoire' },
  { name: 'Réalisations', href: '/projets' },
];

export const services = [
  {
    id: 'agents',
    title: 'Agents IA & Chatbots',
    description: 'Assistants internes et clients personnalisés, avec supervision et amélioration continue.',
    color: '#fad24b',
    features: [
      'Support, RH, IT, commerce, juridique',
      'Personnalisation par contexte',
      'Logs et feedback intégrés',
    ],
  },
  {
    id: 'rag',
    title: 'RAG sur données privées',
    description: 'Recherche sémantique + génération contrôlée avec réponses sourcées.',
    color: '#3dd3ee',
    features: [
      'Connexion multi-sources',
      'Réponses sourcées et traçables',
      'Gestion RBAC et conformité',
    ],
  },
  {
    id: 'nlp',
    title: 'NLP & Automatisation',
    description: 'Extraction, classification et génération de textes contrôlée.',
    color: '#ff8c19',
    features: [
      "Extraction d'informations",
      'Classification documentaire',
      'Résumé et structuration',
    ],
  },
  {
    id: 'vision',
    title: 'Vision & OCR',
    description: 'OCR et extraction structurée avec pipelines robustes.',
    color: '#b4dc19',
    features: [
      'Lecture de documents',
      'Détection et classification',
      'Contrôle qualité intégré',
    ],
  },
];

export const expertise = [
  {
    category: 'Back-end & APIs',
    items: ['Python', 'FastAPI', 'Flask', 'Microservices'],
    color: '#61525a',
  },
  {
    category: 'Front Web',
    items: ['React', 'Next.js', 'Dashboards', 'Interfaces métier'],
    color: '#3dd3ee',
  },
  {
    category: 'Mobile',
    items: ['React Native', 'Apps B2B', 'Apps B2C'],
    color: '#fad24b',
  },
  {
    category: 'Data & IA',
    items: ['ETL', 'Pipelines', 'Versioning', 'Qualité'],
    color: '#ff8c19',
  },
  {
    category: 'Déploiement',
    items: ['Docker', 'Kubernetes', 'AWS', 'CI/CD'],
    color: '#b4dc19',
  },
];

export const changeManagement = [
  {
    title: 'Cadrage usages',
    description: 'Identification des tâches automatisables et définition des workflows',
    icon: 'Target',
  },
  {
    title: 'Adoption',
    description: 'Ateliers métiers, documentation et système de feedback',
    icon: 'Users',
  },
  {
    title: 'Formation',
    description: 'Formation utilisateurs, référents et sensibilisation sécurité',
    icon: 'GraduationCap',
  },
  {
    title: 'Gouvernance',
    description: "KPI d'usage, politique de données et amélioration continue",
    icon: 'BarChart3',
  },
];

export const offers = [
  {
    id: 'discovery',
    name: 'AI Discovery Sprint',
    duration: '2 à 4 semaines',
    description: "Identification des cas d'usage et prototype rapide",
    features: [
      "Analyse des cas d'usage prioritaires",
      'Étude données et contraintes',
      'Prototype fonctionnel',
      "Plan d'accompagnement",
    ],
    color: '#fad24b',
    popular: false,
  },
  {
    id: 'production',
    name: 'RAG/Agent Production',
    duration: '6 à 12 semaines',
    description: 'Solution IA complète prête pour la production',
    features: [
      'Ingestion & vectorisation',
      'API + interface + monitoring',
      'Évaluation qualité',
      'Formation équipes',
    ],
    color: '#3dd3ee',
    popular: true,
  },
  {
    id: 'product',
    name: 'Produit IA Complet',
    duration: 'Mission continue',
    description: "Développement et maintenance d'un produit IA sur mesure",
    features: [
      'Développement web/mobile + IA',
      'Itérations agiles',
      'Maintenance et supervision',
      'Montée en compétence',
    ],
    color: '#ff8c19',
    popular: false,
  },
];

export const targets = [
  {
    name: 'PME / ETI',
    description: "Industrialiser l'IA rapidement sans recruter une équipe complète",
    icon: 'Building2',
  },
  {
    name: 'Startups & SaaS',
    description: "Intégrer l'IA pour se différencier et accélérer la roadmap",
    icon: 'Rocket',
  },
  {
    name: 'Document-driven',
    description: 'Santé, assurance, éducation, médias où texte et documents représentent un coût',
    icon: 'FileText',
  },
];

export const stats = [
  { value: '10+', label: "Années d'expérience" },
  { value: '50+', label: 'Projets livrés' },
  { value: '95%', label: "Taux d'adoption" },
  { value: '3x', label: 'Gain de productivité' },
];

export const calendlyUrl = 'https://calendly.com/saeran-ion/30min';

// About Page Data
export const founders = [
  {
    id: 'aymar',
    name: 'Aymar Monnoyeur',
    role: 'Co-fondateur — Intelligence sectorielle & bases documentaires',
    image: 'https://customer-assets.emergentagent.com/job_indexvec-ai/artifacts/f9keezek_aymar.webp',
    bio: [
      "Issu du monde de l'analyse sectorielle, Aymar Monnoyeur a fondé Businesscoot en 2018. Depuis, plus de 2 000 analyses sectorielles ont été produites à destination de banques, fonds d'investissement, cabinets de conseil et grandes entreprises.",
      "Dès 2020, Aymar intègre des briques d'intelligence artificielle dans les processus de production de Businesscoot avec une conviction forte.",
    ],
    quote: "L'IA doit améliorer l'accès à l'information et accélérer la production, tout en laissant aux analystes les tâches à plus forte valeur ajoutée — prévisions, analyses stratégiques, tailles de marché — là où l'expertise humaine reste indispensable.",
    achievements: [
      'Création de SectorAI, IA dédiée à l\'analyse sectorielle',
      'Rachat d\'IndexPresse en 2024, base de données historique',
      'Productivité multipliée par trois chez IndexPresse',
    ],
    clients: ['Kea Partners', 'Crédit Mutuel', 'Crédit Agricole', 'Bouygues Construction', 'Roland Berger', 'Natixis', 'Initiative & Finance', 'METRO', 'Pierre Fabre'],
  },
  {
    id: 'aniss',
    name: 'Aniss Bentebib',
    role: 'Co-fondateur — Intelligence artificielle & ingénierie des données',
    image: 'https://customer-assets.emergentagent.com/job_glassmorphic-7/artifacts/p3cro4gg_Capture%20d%E2%80%99e%CC%81cran%202026-01-03%20a%CC%80%2016.06.03.png',
    bio: [
      "Issu de la recherche académique en traitement automatique du langage naturel (NLP), Aniss Bentebib fait partie des profils qui ont très tôt appliqué les modèles de langage avancés à des usages professionnels concrets.",
      "Son expertise couvre l'ensemble de la chaîne IA, de la structuration de données complexes jusqu'au déploiement d'agents intelligents en production.",
    ],
    specialties: [
      'Structuration et transformation de données hétérogènes en actifs exploitables par des LLM',
      'Intégration d\'agents IA dans des environnements métiers (CMS, plateformes internes)',
      'Entraînement, optimisation et orchestration de modèles et d\'agents spécialisés',
    ],
    awards: [
      { rank: '1er', title: 'F\'AI\'R Hackathon International', organizer: 'IBM, Microsoft & Ambassade UK', icon: 'Trophy' },
      { rank: '1er', title: 'IA écologique – Pau', organizer: 'Modèles optimisés faible consommation', icon: 'Leaf' },
      { rank: '2e', title: 'Hackathon Capgemini Nantes', organizer: 'Algorithmique', icon: 'Award' },
    ],
    stats: [
      { value: '58+', label: 'Projets IA' },
      { value: '20', label: 'APIs développées' },
      { value: '9', label: 'Apps mobiles' },
    ],
  },
];

export const collaboration = {
  title: 'Leur collaboration et la naissance d\'Indexcore',
  subtitle: 'Vision métier + Excellence technologique',
  achievements: [
    'Transformation de Businesscoot en SectorAI, l\'une des IA d\'analyse sectorielle les plus complètes du marché français',
    'Modernisation des processus IndexPresse avec une productivité multipliée par trois',
    'Conception et déploiement d\'agents IA intégrés aux outils de production existants',
  ],
  conclusion: 'C\'est de cette expérience terrain, acquise sur des projets réels et à grande échelle, qu\'est né Indexcore : une structure dédiée à l\'accompagnement des entreprises dans l\'intégration efficace, pragmatique et durable de l\'IA.',
};

export const approach = [
  {
    title: 'Outils IA clés en main',
    description: 'Améliorer la performance sur des tâches précises',
    icon: 'Wrench',
  },
  {
    title: 'Refonte de workflows',
    description: 'Réduire les coûts et concentrer l\'humain sur les tâches à forte valeur ajoutée',
    icon: 'RefreshCw',
  },
  {
    title: 'Organisation des données',
    description: 'Rendre l\'information immédiatement accessible et gagner en productivité',
    icon: 'Database',
  },
];

export const differentiators = [
  {
    title: 'Expérience concrète et précoce',
    description: 'Notre cœur de métier — l\'analyse sectorielle — a été transformé par l\'IA dès 2019. Nous avons dû intégrer très tôt les LLM dans des processus critiques de production.',
    icon: 'Clock',
  },
  {
    title: 'Expertise données complexes',
    description: 'Scans de documents, tableaux multi-entrées, documents techniques spécialisés — nous avons développé des méthodes robustes pour rendre ces données exploitables.',
    icon: 'FileStack',
  },
  {
    title: 'Workflows métiers repensés',
    description: 'Outils pleinement intégrés aux logiciels de production avec une capacité de traitement multipliée par trois.',
    icon: 'Workflow',
  },
];
